import React from "react";
import { useContext } from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { toast } from "Components/DesignSystem/Toast/useToast";
import AuthManager from "../../../Common/AuthManager";
import { AppContext } from "../../../Context/AppContext";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import Bootbox from "../../../Common/BootBoxManager";
import GMSBorderlessButton from "../../Common/components/GMSBorderlessButton";
import Label from "../../Common/components/Label";
import BuilderPreviewComponentList from "./Components/BuilderPreviewComponentList.jsx";
import GMSButton from "../../Common/components/GMSButton";
import GMSFillButton from "../../Common/components/GMSFillButton";
import ModalContainer from "Components/Common/Modal/ModalContainer";
import ModalBody from "Components/Common/Modal/ModalBody";
import BackArrowIcon from "../../Common/components/BackArrowIcon";
import MenuIcon from "../../Common/components/MenuIcon";
import "./Components/BuilderStyle.css";
import EyeIcon from "../../Common/components/EyeIcon";
import ChannelPreview from "./Components/ChannelPreview";
import { CSSTransition } from "react-transition-group";
import { BuilderContext } from "./BuilderContext";
import BuilderPreviewList from "./Components/BuilderPreviewList";
import { refreshBuilderApi } from "api/Builder";

const BuilderDetailManage = ({ builderId, builderType }) => {
  const { partyId, format_builder, platformInfo, masterdata } =
    useContext(BuilderContext);

  const navigate = useNavigate();
  const appData = useContext(AppContext);
  const [selectedBuilder, setSelectedBuilder] = useState(null);
  const [fullBuilderData, setFullBuilderData] = useState(null);
  const [builderData, setBuilderData] = useState(null);
  const [clipText, setClipText] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showPromotePopup, setShowPromotePopup] = useState(false);
  const [showUnpublishPopup, setShowUnpublishPopup] = useState(false);
  const [showRollbackPopup, setShowRollbackPopup] = useState(false);
  const [builderImage, setBuilderImage] = useState(null);
  const [builderImages, setBuilderImages] = useState([]);
  const modalOpen = () => setShowPopup(true);
  const modalClose = () => setShowPopup(false);
  const modalPromoteOpen = () => setShowPromotePopup(true);
  const modalPromoteClose = () => setShowPromotePopup(false);
  const modalUnpublishOpen = () => setShowUnpublishPopup(true);
  const modalUnpublishClose = () => setShowUnpublishPopup(false);
  const modalRollbackClose = () => setShowRollbackPopup(false);
  const modalRollbackOpen = () => setShowRollbackPopup(true);
  const placeHolderImage = "https://cdn1.vectorstock.com/i/thumb-large/50/20/no-photo-or-blank-image-icon-loading-images-vector-37375020.jpg";
  

  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [showLoader, setShowLoader] = useState(true);

  const [builderPreview, setBuilderPreview] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showChannel, setShowChannel] = useState(false);
  const [channelResponse, setChannelResponse] = useState(null);
  const [showBuilder, setShowBuilder] = useState(false);
  const [merchantKey, setMerchantKey] = useState("");
  const [token, setToken] = useState("");
  const [selectedAttributes, setselectedAttributes] = useState([]);
  const [loadAttributes, setLoadAttributes] = useState(true);

  useEffect(() => {
    if (builderId !== null) {
      loadBuilderDetails(builderId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [builderId]);

  async function loadBuilderDetails(builderId, navigateToDraft = false) {
    setFullBuilderData(null);
    setShowLoader(true);
    let ret = await ServiceWrapper.doGet(
      `${api_base_url}builder/${builderId}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (ret.data && ret.data.done) {
      setFullBuilderData(ret?.data?.data);
      
      setShowLoader(false);
      if (navigateToDraft) {
        navigate({
  pathname: `/workspace/empty`
}, {
  replace: true
});
        navigate({
  pathname: `/gms/builder/detail/${getMainBuilder().uid}`,
  search: `?version=Draft`
});
        // updateBuilderType("Draft");
      }
    } else {
      setShowLoader(false);
      // toast.error(ret?.data?.message ?? "Somethig went wrong");
      navigate({
  pathname: `/gms/builder`
});
    }
  }

  useEffect(() => {
    if (fullBuilderData) {
      const options = [
        { type: "Live", enabled: fullBuilderData.live },
        { type: "Draft", enabled: fullBuilderData.draft },
        { type: "Rollback", enabled: fullBuilderData.rollback },
      ];

      let selectedOption = options.find((option) => option.enabled);
      if (builderType) {
        selectedOption = options.find((option) => option.type === builderType);
        if (!selectedOption.enabled) {
          selectedOption = options.find((option) => option.enabled);
        }
      }

      if (selectedOption) {
        updateBuilderType(selectedOption.type);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullBuilderData]);

  useEffect(() => {
    if (builderData?.builder?.global_filter?.length > 0) {
      setLoadAttributes(true);
      updateAttributeList(builderData.builder.global_filter);
    } else {
      setLoadAttributes(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterdata, builderData]);

  const updateAttributeList = (globalFilter) => {
    if (masterdata) {
      let cat_list = [];
      let attr_list = [];
      let attr_for_cat = [];
      for (let cat in masterdata) {
        attr_for_cat = [];
        cat_list.push({
          label: masterdata[cat]["name"],
          value: masterdata[cat]["id"],
        });
        const cat_attr = masterdata[cat]["attributes"];
        for (let attr in cat_attr) {
          attr_for_cat.push({
            label: cat_attr[attr]["name"],
            value: cat_attr[attr]["id"],
          });
        }
        attr_list.push({
          label: masterdata[cat]["name"],
          options: attr_for_cat,
        });
      }

      if (globalFilter?.length > 0) {
        const uniqueValues = new Set();
        const filteredData = attr_list.reduce((acc, obj) => {
          const matchingOptions = obj.options.filter((opt) =>
            globalFilter.includes(opt.value)
          );
          if (matchingOptions.length > 0) {
            matchingOptions.forEach((opt) => {
              if (!uniqueValues.has(opt.value)) {
                acc.push({ label: opt.label, value: opt.value });
                uniqueValues.add(opt.value);
              }
            });
          }
          return acc;
        }, []);
        setselectedAttributes(filteredData);
        setLoadAttributes(false);
      }
    }
  };

  const checkPermission = (permission, successAction, failureMessage) => {
    if (appData.pm.checkPermission(permission)) {
      successAction();
    } else {
      toast.info(failureMessage);
    }
  };

  async function rollbackOldBuilder() {
    try {
      const res = await ServiceWrapper.doGet(
        `${api_base_url}/builder/${getMainBuilder().uid}/rollback`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (res.data && res.data.done) {
        toast.success(res.data.message);

        loadBuilderDetails(getMainBuilder().uid);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  async function deleteBuilder() {
    toast.info("Please wait while we delete selected Builder...");
    const builderObject = { version: selectedBuilder.toLowerCase() };
    try {
      const res = await ServiceWrapper.doDelete(
        `${api_base_url}builder/${getMainBuilder().uid}`,
        builderObject,
        null,
        AuthManager.getGmsToken()
      );
      if (res.data && res.data.done) {
        loadBuilderDetails(getMainBuilder().uid);
        toast.success(res?.data?.message ?? "Deletion successful");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(`Error occurred while deleting. ${error.message}`);
    }
  }

  async function unPublishBuilder() {
    // removed
    toast.info("Please wait while we delete selected Builder...");
    try {
      const res = await ServiceWrapper.doGet(
        `${api_base_url}builder/${getMainBuilder().uid}/unpublish`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (res.data && res.data.done) {
        // removed
        loadBuilderDetails(getMainBuilder().uid, true);
        toast.success(res?.data?.message ?? "Deletion successful");
      } else {
        // removed
        toast.error(res.data.message);
      }
    } catch (error) {
      // removed
      toast.error(`Error occurred while deleting. ${error.message}`);
    }
  }

  async function promoteBuilderToLive() {
    // removed
    toast.success("Promotion started ....");
    let res = await ServiceWrapper.doGet(
      `${api_base_url}/builder/${getMainBuilder().uid}/promote`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (res.data.done) {
      toast.success(res.data.message);
      // removed
      loadBuilderDetails(getMainBuilder().uid);
    } else {
      // removed
      toast.error(res.data.message);
    }
  }

  async function preview_channel() {
    let res = await ServiceWrapper.doGet(
      `${api_base_url}party/${partyId}/channel`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (res.data.done) {
      setShowChannel((prev) => (prev = !prev));
      setChannelResponse(res.data.data);
    } else {
      console.log("handle error");
    }
  }

  async function preview_builder_Details() {
    const final_builder = format_builder(fullBuilderData?.live);
    
    if(getMainBuilder()?.uid) refreshBuilderApi(getMainBuilder()?.uid)

    let res = await ServiceWrapper.doPost(
      `${api_base_url}builder/model`,
      final_builder,
      null,
      AuthManager.getGmsToken()
    );
    if (res && !res.errorfound) {
      if (res.data && res.data.done) {
        setShowPreview(true);
        setBuilderPreview(res.data.data);
        return true;
      } else {
        setShowPreview(false);
        toast.error(res.data.message);
        return false;
      }
    } else {
      setShowPreview(false);
      toast.error("Error while loading Builder preview");
      return false;
    }
  }

  const updateBuilderType = async (value) => {
    setSelectedBuilder(value);
    let data;
    if (value === "Live") {
      data = getLiveBuilder(fullBuilderData)
    }
    if (value === "Draft") {
      data = getDraftBuilder(fullBuilderData);
    }
    if (value === "Rollback") {
      data = getRollbackBuilder(fullBuilderData);
    }
    setBuilderData(data);
    if (!!data.builder?.builder_image_detail) {
      let final = JSON.parse(
        data.builder.builder_image_detail.replace(/'/g, '"')
      );
      if (
        final &&
        final.length > 0 &&
        final[0].JPEG_IMAGES &&
        final[0].JPEG_IMAGES.default_image
      ) {
        let images = [];
        images.push(final[0].JPEG_IMAGES.default_image);
        images = images.concat(final[0].JPEG_IMAGES.images);
        setBuilderImage(final[0].JPEG_IMAGES.default_image);
        setBuilderImages(images);
      }
      else{
        setBuilderImage(null);
        setBuilderImages([]);
      }
    }
  };

  function getMainBuilder() {
    if (fullBuilderData) {
      return (
        fullBuilderData?.live?.builder ??
        fullBuilderData?.draft?.builder ??
        fullBuilderData?.rollback?.builder
      );
    }
  }

  function handle_clipbord(text) {
    navigator.clipboard.writeText(text).then(() => setClipText(text));
  }

  function navigateToEditPage() {
    navigate({
  pathname: `/gms/builder/edit/${getMainBuilder().uid}`
});
  }

  function navigateToBuilderListPage() {
    navigate({
  pathname: `/gms/builder`
});
  }

  function getLiveBuilder(builder) {
    return builder?.live || null;
  }

  function getDraftBuilder(builder) {
    return builder?.draft || null;
  }

  function getRollbackBuilder(builder) {
    return builder?.rollback || null;
  }

  const checkPermissionAndPreview = (previewType) => {
    if (appData.pm.checkPermission("gmskbcapps_preview")) {
      if (previewType === "channel") {
        preview_channel();
      } else if (previewType === "builder") {
        preview_builder_Details();
      }
    } else {
      toast.info("You don't have permission to preview the builder");
    }
  };

  const handleDelete = () =>
    checkPermission(
      "gmskbcapps_delete",
      () =>
        Bootbox.confirm("", `${builderData?.builder?.name}`, false, [
          deleteBuilder,
        ]),
      "You don't have permission to delete the builder"
    );

  const handleEdit = () => modalOpen();

  const handleRollback = () =>
    checkPermission(
      "gmskbcapps_publish",
      rollbackOldBuilder,
      "You don't have permission to rollback the builder"
    );

  const renderMenu = () => {
    switch (selectedBuilder) {
      case "Live":
        if (getDraftBuilder(fullBuilderData) === null) {
          return (
            <>
              <li className="">
                <GMSBorderlessButton
                  name="Edit"
                  color="#000"
                  onClick={handleEdit}
                />
              </li>
            </>
          );
        }
        break;
      case "Draft":
        return (
          <>
            {
              <li className="">
                <GMSBorderlessButton
                  name="Edit"
                  color="#000"
                  onClick={navigateToEditPage}
                />
              </li>
            }

            <li className="">
              <GMSBorderlessButton
                name="Delete"
                color={"#000"}
                onClick={handleDelete}
              />
            </li>
          </>
        );
      case "Rollback":
        if (getRollbackBuilder(fullBuilderData) !== null) {
          return (
            <>
              <li className="">
                <GMSBorderlessButton
                  name="Rollback"
                  color="#000"
                  onClick={() => {
                    modalRollbackOpen();
                  }}
                />
              </li>
              <li className="">
                <GMSBorderlessButton
                  name="Delete"
                  color={"#000"}
                  onClick={handleDelete}
                />
              </li>
            </>
          );
        }
        break;

      default:
        if (
          getLiveBuilder(fullBuilderData) !== null &&
          getRollbackBuilder(fullBuilderData) !== null
        ) {
          return (
            <>
              <li className="">
                <GMSBorderlessButton
                  name="Rollback"
                  color="#000"
                  onClick={handleRollback}
                />
              </li>
            </>
          );
        }
    }
  };

  return (
    <>
      {showLoader && (
        <div>
          <div className="">
            <div className="border-bottom pe-2 ps-4 row">
              <div className="col-6">
                <div className="p-3 col-4 skeleton"></div>
              </div>
              <div className="col-6 justify-content-end pe-1 row">
                <div className="skeleton col-6"></div>
              </div>
            </div>
          </div>
          <div className="pb-3 pe-2 ps-4 border-bottom">
            <div className="pt-4 ps-2 row">
              <div className="p-3 col-6 skeleton"></div>
              <div className="mt-3 mb-4 col-3 ms-5 skeleton"></div>
            </div>
            <div className="p-4 col-6 skeleton"></div>
          </div>
          <div className="p-4">
            <div className="p-2 border rounded">
              <div className="mt-3 ms-5 ps-3 row">
                <div className="p-3 col-2 skeleton"></div>
                <div className="p-3 col-2 ms-5 skeleton"></div>
                <div className="p-2 col-2 ms-5 skeleton"></div>
              </div>
              <div className="mt-5 ms-3 ps-5">
                <div className="p-3 col-8 skeleton"></div>
              </div>
              <div className="mt-5 ms-3 ps-5">
                <div className="p-3 col-8 skeleton"></div>
              </div>
              <div className="mt-5 ms-3 ps-5">
                <div className="p-3 col-8 skeleton"></div>
              </div>
            </div>
          </div>
          <div className="p-3 col-2 ms-4 skeleton"></div>
        </div>
      )}
      {!showLoader && fullBuilderData && builderData ? (
        <div className="p-0">
          <div className="pt-0 pb-2 d-flex align-items-center justify-content-between">
            <div className="w-40 d-flex container-fluid align-items-center ">
              <BackArrowIcon
                navigateToBuilderListPage={() => navigateToBuilderListPage()}
              />
              &nbsp;&nbsp;&nbsp;
              <Label
                message={builderData?.builder?.short_name}
                fontWeight={"600"}
                fontSize={"1.125"}
              />
              &nbsp; &nbsp;
              <div className="border-0 input-group w-25">
                <select data-testid="builder-builderdetailmanage-select-1"
                  className="p-2 shadow-none fst-normal border-1 form-select"
                  style={{ fontSize: "0.75rem", fontWeight: "600" }}
                  value={selectedBuilder}
                  onChange={(e) => updateBuilderType(e.target.value)}
                >
                  {builderType === null && (
                    <>
                      {fullBuilderData.live && (
                        <option value={"Live"}>Live</option>
                      )}
                      {fullBuilderData.draft && (
                        <option value={"Draft"}>Draft</option>
                      )}
                      {fullBuilderData.rollback && (
                        <option value={"Rollback"}>Rollback</option>
                      )}
                    </>
                  )}
                  {builderType === "Live" && (
                    <>
                      {fullBuilderData.live && (
                        <option value={"Live"}>Live</option>
                      )}
                      {fullBuilderData.draft && (
                        <option value={"Draft"}>Draft</option>
                      )}
                      {fullBuilderData.rollback && (
                        <option value={"Rollback"}>Rollback</option>
                      )}
                    </>
                  )}
                  {builderType === "Draft" && (
                    <>
                      {fullBuilderData.draft && (
                        <option value={"Draft"}>Draft</option>
                      )}
                      {fullBuilderData.live && (
                        <option value={"Live"}>Live</option>
                      )}
                      {fullBuilderData.rollback && (
                        <option value={"Rollback"}>Rollback</option>
                      )}
                    </>
                  )}
                  {builderType === "Rollback" && (
                    <>
                      {fullBuilderData.rollback && (
                        <option value={"Rollback"}>Rollback</option>
                      )}
                      {fullBuilderData.draft && (
                        <option value={"Draft"}>Draft</option>
                      )}
                      {fullBuilderData.live && (
                        <option value={"Live"}>Live</option>
                      )}
                    </>
                  )}
                </select>
              </div>
            </div>
            <div
              className="d-flex container-fluid justify-content-end align-items-center w-60"
              style={{ float: "end" }}
            >

              {selectedBuilder === "Live" && (
                <div className="d-flex align-items-center ps-3 pe-3 preview-button-border ms-2 me-2">
                  <EyeIcon></EyeIcon>
                  <GMSBorderlessButton
                    name="Preview Builder"
                    onClick={() => {
                      checkPermissionAndPreview("channel");
                    }}
                  />
                </div>
              )}

              {selectedBuilder === "Live" && (
                <div className="d-flex ps-3 pe-3 align-items-center preview-button-border me-0">
                  <EyeIcon></EyeIcon>
                  <GMSBorderlessButton
                    name="Preview Products"
                    onClick={() => {
                      checkPermissionAndPreview("builder");
                    }}
                  />
                </div>
              )}

              {selectedBuilder === "Draft" && fullBuilderData.draft && (
                <button
                  name={"publishToLive"}
                  data-testid="builder-publish-to-live-btn"
                  onClick={() => {
                    modalPromoteOpen();
                  }}
                  style={{ padding: "7px", fontSize: "14px" }}
                  className="button-fill ms-2 pe-3 ps-3"
                >
                  {"Publish to live"}
                </button>
              )}

              {selectedBuilder === "Live" && (
                <button
                  name={"unpublish"}
                  data-testid="builder-unpublish-btn"
                  onClick={() => {
                    modalUnpublishOpen();
                  }}
                  style={{ padding: "7px", fontSize: "14px" }}
                  className="button-fill ms-2 pe-3 ps-3"
                >
                  {"Unpublish"}
                </button>
              )}
              {selectedBuilder === "Live" &&
              getDraftBuilder(fullBuilderData) === null ? (
                <li
                  className="nav-item dropdown"
                  style={{ listStyleType: "none" }}
                >
                  <div role="group" className="ps-3 pe-3 ">
                    <i id="btnGroupDrop1" className="pt-1 " />
                    <MenuIcon />
                    <ul
                      className="bg-white dropdown-menu ps-0 pe-0"
                      aria-labelledby="btnGroupDrop1"
                      style={{
                        fontFamily: "Noto Sans",
                        fontSize: "0.875rem",
                        textAlignLast: "center",
                      }}
                    >
                      {renderMenu()}
                    </ul>
                  </div>
                </li>
              ) : (
                <div></div>
              )}
              {selectedBuilder === "Draft" && (
                <li
                  className="nav-item dropdown"
                  style={{ listStyleType: "none" }}
                >
                  <div role="group" className="ps-3 pe-3 ">
                    <i id="btnGroupDrop1" className="pt-1 " />
                    <MenuIcon />
                    <ul
                      className="bg-white dropdown-menu ps-0 pe-0"
                      aria-labelledby="btnGroupDrop1"
                      style={{
                        fontFamily: "Noto Sans",
                        fontSize: "0.875rem",
                        textAlignLast: "center",
                      }}
                    >
                      {renderMenu()}
                    </ul>
                  </div>
                </li>
              )}
              {selectedBuilder === "Rollback" && (
                <li
                  className="nav-item dropdown"
                  style={{ listStyleType: "none" }}
                >
                  <div role="group" className="ps-3 pe-3 ">
                    <i id="btnGroupDrop1" className="pt-1 " />
                    <MenuIcon />
                    <ul
                      className="bg-white dropdown-menu ps-0 pe-0"
                      aria-labelledby="btnGroupDrop1"
                      style={{
                        fontFamily: "Noto Sans",
                        fontSize: "0.875rem",
                        textAlignLast: "center",
                      }}
                    >
                      {renderMenu()}
                    </ul>
                  </div>
                </li>
              )}
            </div>
          </div>
          <div
            className="pt-3 pb-2 mt-0 mb-4 builder-border ps-4 "
            style={{
              background: "#f2f2f2",
              borderColor: builderData.builder.is_deleted
                ? "#dc3545"
                : "#caccd0",
            }}
          >
            <div className="ps-2">
              <div className="row">
                <div className="col-md-4">
                  <label
                    className="pb-1"
                    style={{
                      fontWeight: "400",
                      fontFamily: "Noto Sans",
                    }}
                  >
                    Name
                  </label>
                  <br />
                  <Label message={builderData?.builder?.name} />
                </div>
                <div className="col-md-3 ">
                  <label
                    className="pb-1"
                    style={{
                      fontWeight: "400",
                      fontFamily: "Noto Sans",
                    }}
                  >
                    Short Named
                  </label>
                  <br />
                  <Label message={builderData?.builder?.short_name} />
                </div>
                <div className="align-self-start col-md-3">
                  {true && (
                    <>
                      <label
                        className="pt-1 pb-1"
                        style={{
                          fontWeight: "400",
                          fontFamily: "Noto Sans",
                        }}
                      >
                        UID
                      </label>
                      <div className="id">
                        <div
                          className="badge id ps-0"
                          style={{
                            color: "#5C5F62",
                            fontFamily: "Noto Sans",
                            fontSize: ".875rem",
                            fontWeight: "400",
                          }}
                        >
                          {builderData?.builder?.uid}
                        </div>
                        &nbsp;
                        <i data-testid="builder-builderdetailmanage-i-1"
                          className={`${
                            clipText === null ? "far" : "fas"
                          } fa-clipboard`}
                          style={{
                            cursor: "pointer",
                            color: "rgb(9, 28, 170)",
                          }}
                          onClick={() =>
                            handle_clipbord(builderData?.builder?.uid)
                          }
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="pt-3 row">
                <div className="mb-3 col-md-5">
                  <label
                    className="pb-1"
                    style={{
                      fontWeight: "400",
                      fontFamily: "Noto Sans",
                    }}
                  >
                    Description
                  </label>
                  <br />
                  <Label message={builderData?.builder?.description} />
                </div>
              </div>
              <div className="pt-3 row">
              <div className="tw-w-[16%] tw-p-2">
                <div className="tw-relative tw-rounded tw-w-[280px] tw-aspect-[1.87/1] tw-bg-[#F7F7F7] tw-flex-shrink-0 tw-border-[#F2F2F2]">
                  {
                    builderImage &&
                    <i data-testid="builder-builderdetailmanage-i-2"
                      className={`${
                        clipText === null ? "far" : "fas"
                      } fa-clipboard tw-absolute tw-top-3 tw-right-3`}
                      style={{
                        cursor: "pointer",
                        color: "rgb(9, 28, 170)",
                      }}
                      onClick={() =>
                        handle_clipbord(builderImage)
                      }
                    />
                  }
                  <img className="tw-p-2.5 tw-w-[280px] tw-aspect-[1.87/1]" src={builderImage? builderImage : placeHolderImage} alt="Builder" loading="lazy" />
                </div>
                <div className="tw-flex tw-w-48 tw-overflow-x-auto">
                  {builderImages && builderImages?.length > 0 ? builderImages?.map((imageUrl, index) => (
                    <div role="button" data-testid={`builder-image-thumbnail-${index}-${imageUrl}`} aria-label="Select image" key={index + imageUrl} className="tw-rounded tw-mt-1 tw-w-[45px] tw-aspect-[1.87/1] tw-bg-[#F7F7F7] tw-flex-shrink-0 tw-border-[#F2F2F2] tw-mx-0.5" onClick={() => {setBuilderImage(imageUrl);}}>
                      <img className="tw-w-[45px] tw-aspect-[1.87/1]" src={imageUrl ? imageUrl : placeHolderImage} alt="" onError={({currentTarget}) => {
                        currentTarget.onerror = null;
                        currentTarget.src = placeHolderImage;
                      }} loading="lazy"/>
                    </div>
                  )) : null}
                </div>
              </div>
              </div>
            </div>
          </div>

          <div
            style={{
              background: "#f2f2f2",
              borderColor: "#caccd0",
            }}
            className="pt-3 pb-2 mb-4 builder-border ps-4"
          >
            <div className="filter-title filter-text">
              <label>Pre-filters attribute</label>
            </div>
            <label className="filter-caption filter-text">Attribute</label>
            <div className="pb-4 row form-group pe-4">
              <div className="col-md-12 d-flex align-items-center">
                <div className="selected-category-items">
                  <div className="flex-wrap d-flex">
                    <>
                      {selectedAttributes?.length > 0 ? (
                        selectedAttributes.map((item, index) => {
                          return (
                            <div className="p-2 selected-1" key={index}>
                              <input data-testid={`builder-builderdetailmanage-input-2-${index}`}
                                type="checkbox"
                                className="text-white btn-check"
                                name="options-outlined"
                                id={`success-outlined${index}`}
                                autoComplete="off"
                                // checked={getChecked(item.id)}
                              />

                              <label
                                className="btn btn-outline-primary-1 btn-sm"
                                htmlFor={`success-outlined`}
                              >
                                {item.label}
                              </label>
                            </div>
                          );
                        })
                      ) : (
                        <div>
                          {loadAttributes ? "Loading ..." : "No Data Found"}
                        </div>
                      )}
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ms-4 me-4">
            <BuilderPreviewComponentList
              componentList={builderData.components}
            />
          </div>
          {showPreview && builderPreview && (
            <CSSTransition
              timeout={1000}
              key={showPreview}
              classNames={{
                enterActive: "animate__animated animate__flipInX",
                exitActive: "animate__animated animate__flipOutX",
              }}
            >
              <BuilderPreviewList
                builderPreview={builderPreview}
                setShowPreview={setShowPreview}
              />
            </CSSTransition>
          )}
          {showChannel && channelResponse && (
            <CSSTransition
              timeout={1000}
              key={showChannel}
              classNames={{
                enterActive: "animate__animated animate__flipInX",
                exitActive: "animate__animated animate__flipOutX",
              }}
            >
              <ChannelPreview
                channelResponse={channelResponse}
                setShowChannel={setShowChannel}
                setShowBuilder={setShowBuilder}
                setMerchantKey={setMerchantKey}
                platformInfo={platformInfo}
                setToken={setToken}
              />
            </CSSTransition>
          )}
        </div>
      ) : (
        <div>{!showLoader && "No data found"}</div>
      )}
      <ModalContainer
        isOpen={showPopup}
        setOpen={modalClose}
      >
        <ModalBody>
          <div className="pt-3 text-center ps-3 pe-3">
            <div className="d-inline-block align-items-center">
              <Label
                message={"All edits will be saved as"}
                fontWeight={"600"}
                fontSize={"1.125"}
              />
              &nbsp;
              <span className="badge ps-2 pe-2 chip chip-draft">{"Draft"}</span>
              <Label
                message={"version."}
                fontWeight={"600"}
                fontSize={"1.125"}
              />
            </div>
            <br />
            <br />
            <Label
              message={"Would you like to proceed?"}
              fontWeight={"400"}
              fontSize={"1"}
            />
            <div className="pb-3 mt-2 d-flex justify-content-center">
              <GMSButton name="Cancel" onClick={() => modalClose()} />
              &nbsp; &nbsp;
              <GMSFillButton
                name="Yes, Proceed to edit"
                onClick={() => {
                  navigateToEditPage();
                  modalClose();
                }}
              />
            </div>
          </div>
        </ModalBody>
      </ModalContainer>

      <ModalContainer
        isOpen={showPromotePopup}
        setOpen={modalPromoteClose}
      >
        <ModalBody>
          <div className="pt-3 text-center ps-3 pe-3">
            <div className="flex-wrap d-flex justify-content-between">
              {fullBuilderData &&
                fullBuilderData.draft &&
                !fullBuilderData?.draft.builder?.is_deleted && (
                  <div className="">
                    <Label
                      message={`${builderData?.builder?.name}`}
                      fontWeight={"600"}
                      fontSize={"1.125"}
                    />
                    &nbsp;
                    <span className="badge ps-1 chip chip-draft">
                      {"Draft"}
                    </span>
                    &nbsp;
                    {getLiveBuilder(fullBuilderData) === null ? (
                      <Label
                        message={"will be promoted to Live version"}
                        fontWeight={"600"}
                        fontSize={"1.125"}
                      />
                    ) : (
                      <Label
                        message={"will replace current live version"}
                        fontWeight={"600"}
                        fontSize={"1.125"}
                      />
                    )}
                  </div>
                )}
            </div>

            {fullBuilderData?.live !== null && (
              <div
                className="p-2 mt-3 border-0 d-flex border-grey"
                style={{ backgroundColor: "#EBECF0", borderRadius: "4px" }}
              >
                <div>
                  {fullBuilderData &&
                  fullBuilderData.draft &&
                  fullBuilderData?.draft?.builder?.is_deleted ? (
                    <label style={{ fontSize: ".875rem", fontWeight: "400" }}>
                      On unpublishing draft {fullBuilderData?.name} , Both live
                      & draft version of the builder will remove
                    </label>
                  ) : (
                    <label style={{ fontSize: ".875rem", fontWeight: "400" }}>
                      Previous live version is available anytime to rollback in
                      the state indication dropdown
                    </label>
                  )}
                </div>
              </div>
            )}
            <br />
            <Label
              message={"Would you like to proceed?"}
              fontWeight={"400"}
              fontSize={"1"}
            />
            <div className="pb-3 mt-2 d-flex justify-content-center">
              <GMSButton name="Cancel" onClick={() => modalPromoteClose()} />
              &nbsp; &nbsp;
              <GMSFillButton
                name="Yes, Publish to live"
                onClick={() => {
                  if (appData.pm.checkPermission("gmskbcapps_publish")) {
                    promoteBuilderToLive();
                    modalPromoteClose();
                  } else {
                    toast.info(
                      "You don't have permission to publish/promote the builder"
                    );
                  }
                }}
              />
            </div>
          </div>
        </ModalBody>
      </ModalContainer>

      <ModalContainer
        isOpen={showUnpublishPopup}
        setOpen={modalUnpublishClose}
      >
        <ModalBody>
          <div className="pt-3 text-center ps-3 pe-3">
            <div className="flex-wrap d-flex justify-content-between">
              <div className="">
                <Label
                  message={`${builderData?.builder?.name}`}
                  fontWeight={"600"}
                  fontSize={"1.125"}
                />
                &nbsp;&nbsp;
                <span className="badge ps-1 chip chip-live">{"Live"}</span>
                &nbsp;&nbsp;
                <Label
                  message={` will move to `}
                  fontWeight={"600"}
                  fontSize={"1.125"}
                />
                &nbsp;&nbsp;
                <span className="badge ps-1 chip chip-draft">draft</span>
                &nbsp;&nbsp;
                <Label
                  message={`version.`}
                  fontWeight={"600"}
                  fontSize={"1.125"}
                />
              </div>
            </div>

            <div
              className="p-2 mt-3 mb-3 border-0 d-flex border-grey"
              style={{ backgroundColor: "#EBECF0", borderRadius: "4px" }}
            >
              <label style={{ fontSize: ".875rem", fontWeight: "400" }}>
                Builder will move to draft version & replace old draft.
              </label>
            </div>
            <Label
              message={"Would you like to proceed?"}
              fontWeight={"400"}
              fontSize={"1"}
            />
            <div className="pb-3 mt-2 d-flex justify-content-center">
              <GMSButton name="Cancel" onClick={() => modalUnpublishClose()} />
              &nbsp; &nbsp;
              <GMSFillButton
                name="Yes, Unpublish"
                onClick={() => {
                  if (appData.pm.checkPermission("gmskbcapps_publish")) {
                    unPublishBuilder();
                    modalUnpublishClose();
                  } else {
                    toast.info(
                      "You don't have permission to publish/promote the builder"
                    );
                  }
                }}
              />
            </div>
          </div>
        </ModalBody>
      </ModalContainer>

      <ModalContainer
        isOpen={showRollbackPopup}
        setOpen={modalRollbackClose}
      >
        <ModalBody>
          <div className="pt-3 text-center ps-3 pe-3">
            <div className="flex-wrap d-flex justify-content-between">
              <div className="">
                <Label
                  message={`${builderData?.builder?.name}`}
                  fontWeight={"600"}
                  fontSize={"1.125"}
                />
                &nbsp;&nbsp;
                <span className="badge ps-1 chip chip-old">{"old"}</span>
                &nbsp;&nbsp;
                <Label
                  message={`builder will go to`}
                  fontWeight={"600"}
                  fontSize={"1.125"}
                />
                &nbsp;&nbsp;
                <span className="badge ps-1 chip chip-live">live</span>
                &nbsp;&nbsp;
                <Label
                  message={`version if you rollback.`}
                  fontWeight={"600"}
                  fontSize={"1.125"}
                />
              </div>
            </div>
            <br />
            <Label
              message={"Would you like to proceed?"}
              fontWeight={"400"}
              fontSize={"1"}
            />
            <div className="pb-3 mt-2 d-flex justify-content-center">
              <GMSButton name="Cancel" onClick={() => modalRollbackClose()} />
              &nbsp; &nbsp;
              <GMSFillButton
                name="Yes, Rollback"
                onClick={() => {
                  handleRollback();
                  modalRollbackClose();
                }}
              />
            </div>
          </div>
        </ModalBody>
      </ModalContainer>

      {showBuilder && builderData && (
        <div className="p-0 m-0 w-100 h-100">
          <div className="col card">
            <div className="pt-0 pb-0 d-flex justify-content-between align-items-center">
              <div style={{ float: "left" }}>
                <i data-testid="builder-builderdetailmanage-i-4"
                  id="btnGroupDrop1"
                  className="pt-1 fas fa-angle-left pe-2"
                  style={{
                    fontSize: "1rem",
                    cursor: "pointer",
                    color: "#5c5f62",
                  }}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => {
                    setShowBuilder((prev) => (prev = !prev));
                  }}
                />
                <Label
                  message={builderData.name}
                  fontSize={1.125}
                  fontWeight="700"
                />
              </div>
            </div>
          </div>
          <div className="d-flex w-100">
            <iframe
              style={{ height: "100vh", width: "inherit" }}
              src={`https://apps.compat.io/?builderModel=${builderData.id}&merchantKey=${merchantKey}&authToken=${token}`}
              id="iframe_view_builder"
              title="Product Builder"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BuilderDetailManage;
